//Validation constants
export const namePattern = /^[A-Za-z]+(\s+[A-Za-z]+)*\s*$/;
export const jobCategoryActivityNamePattern = /^[A-Za-z0-9/:\-;_]+(\s+[A-Za-z0-9/:\-;_]+)*\s*$/;
export const jobCategoryActivityPattern = /^[0-9a-zA-Z]*$/;
export const errorMessagesForSubRoleSelection = 'At least one SubRole must be selected.';
export const errorMessages = {
    pattern: 'These characters are not allowed',
};

export const errorMessagesForWorkHourDetails = {
    endDate: 'End Date should be greater than Start Date',
};

export const errorMessagesForReoprt = {
    employer: 'Select workplace details',
    endDate: 'End date must be later than start date',
    rangeOfStartAndEndDate : 'You have exceeded the maximum reporting period of 52 weeks'
};

export const countryNameMaxLength = 20;
export const getMaxLengthErrorMessage = (maxLength: any) => {
    return `Name should not exceed ${maxLength} characters`;
};

export const getRequiredErrorMessage = (fieldName: any) => {
    return `The ${fieldName} field is required`;
};

export const DeletePopupConfirmationMessage = "Are you sure you want to delete?";
export const jobCategoryNameMaxLength = 40;
export const isTrue = "Yes";
export const isFalse = "No";
export const jobSubCategoryAdminCreated = "SystemDefined";
export const jobSubCategoryUserCreated = "UserDefined";
export const contentAsPublished = "PUBLISHED";
export const contentAsDraft = "DRAFT";
export const jobSubCategoryNameMaxLength = 100;
export const contentHeadingMaxLength = 50;
export const contentDescriptionMaxLength = 1000;
export const workActivityNameMaxLength = 30;
export const DeleteWorkActivityPopupConfirmationMessage = "Are you sure you would like to remove?";
export const defaultEmployerForReport = "Select workplace details";
export const rangeOfStartAndEndDateCount = 52;
export const backDatedDateReport = 30;
export const titleForOverview = "Overview";
export const titleForWeeklyBreakdown = "Weekly breakdown";
export const titleForAverageWeek = "Average week";
export const titleForDutyOnCallPeriods = "On-call details";
export const titleForSetTargets = "Set targets";

export const getMaxLengthWithFieldErrorMessage = (fieldName: any, maxLength: any) => {
    return `${fieldName} should not exceed ${maxLength} characters`;
};